/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDevelopmentAreaRequest } from '../models';
// @ts-ignore
import type { CreateDevelopmentDimensionRequest } from '../models';
// @ts-ignore
import type { DevelopmentAreaResponse } from '../models';
// @ts-ignore
import type { DevelopmentCoverageResponse } from '../models';
// @ts-ignore
import type { DevelopmentDimensionResponse } from '../models';
// @ts-ignore
import type { UpdateDevelopmentAreaRequest } from '../models';
// @ts-ignore
import type { UpdateDevelopmentDimensionRequest } from '../models';
/**
 * DevelopmentAreasAdminApi - axios parameter creator
 * @export
 */
export const DevelopmentAreasAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a development area
         * @param {CreateDevelopmentAreaRequest} createDevelopmentAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArea: async (createDevelopmentAreaRequest: CreateDevelopmentAreaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDevelopmentAreaRequest' is not null or undefined
            assertParamExists('createArea', 'createDevelopmentAreaRequest', createDevelopmentAreaRequest)
            const localVarPath = `/api/admin/development-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDevelopmentAreaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a dimension in an area
         * @param {number} areaId 
         * @param {CreateDevelopmentDimensionRequest} createDevelopmentDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDimension: async (areaId: number, createDevelopmentDimensionRequest: CreateDevelopmentDimensionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'areaId' is not null or undefined
            assertParamExists('createDimension', 'areaId', areaId)
            // verify required parameter 'createDevelopmentDimensionRequest' is not null or undefined
            assertParamExists('createDimension', 'createDevelopmentDimensionRequest', createDevelopmentDimensionRequest)
            const localVarPath = `/api/admin/development-areas/{areaId}/dimensions`
                .replace(`{${"areaId"}}`, encodeURIComponent(String(areaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDevelopmentDimensionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a development area
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateArea: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateArea', 'id', id)
            const localVarPath = `/api/admin/development-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deactivate a dimension
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateDimension: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deactivateDimension', 'id', id)
            const localVarPath = `/api/admin/development-dimensions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all development areas, including inactive ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll3: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/development-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Coverage matrix of active dimensions by linked active questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/development-areas/coverage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a development area
         * @param {number} id 
         * @param {UpdateDevelopmentAreaRequest} updateDevelopmentAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArea: async (id: number, updateDevelopmentAreaRequest: UpdateDevelopmentAreaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateArea', 'id', id)
            // verify required parameter 'updateDevelopmentAreaRequest' is not null or undefined
            assertParamExists('updateArea', 'updateDevelopmentAreaRequest', updateDevelopmentAreaRequest)
            const localVarPath = `/api/admin/development-areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevelopmentAreaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a dimension
         * @param {number} id 
         * @param {UpdateDevelopmentDimensionRequest} updateDevelopmentDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimension: async (id: number, updateDevelopmentDimensionRequest: UpdateDevelopmentDimensionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDimension', 'id', id)
            // verify required parameter 'updateDevelopmentDimensionRequest' is not null or undefined
            assertParamExists('updateDimension', 'updateDevelopmentDimensionRequest', updateDevelopmentDimensionRequest)
            const localVarPath = `/api/admin/development-dimensions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDevelopmentDimensionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentAreasAdminApi - functional programming interface
 * @export
 */
export const DevelopmentAreasAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentAreasAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a development area
         * @param {CreateDevelopmentAreaRequest} createDevelopmentAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArea(createDevelopmentAreaRequest: CreateDevelopmentAreaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentAreaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArea(createDevelopmentAreaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.createArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a dimension in an area
         * @param {number} areaId 
         * @param {CreateDevelopmentDimensionRequest} createDevelopmentDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDimension(areaId: number, createDevelopmentDimensionRequest: CreateDevelopmentDimensionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentDimensionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDimension(areaId, createDevelopmentDimensionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.createDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivate a development area
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateArea(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateArea(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.deactivateArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deactivate a dimension
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateDimension(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateDimension(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.deactivateDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all development areas, including inactive ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll3(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DevelopmentAreaResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll3(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.getAll3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Coverage matrix of active dimensions by linked active questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCoverage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentCoverageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCoverage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.getCoverage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a development area
         * @param {number} id 
         * @param {UpdateDevelopmentAreaRequest} updateDevelopmentAreaRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArea(id: number, updateDevelopmentAreaRequest: UpdateDevelopmentAreaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentAreaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArea(id, updateDevelopmentAreaRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.updateArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a dimension
         * @param {number} id 
         * @param {UpdateDevelopmentDimensionRequest} updateDevelopmentDimensionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDimension(id: number, updateDevelopmentDimensionRequest: UpdateDevelopmentDimensionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevelopmentDimensionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDimension(id, updateDevelopmentDimensionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasAdminApi.updateDimension']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentAreasAdminApi - factory interface
 * @export
 */
export const DevelopmentAreasAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentAreasAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a development area
         * @param {DevelopmentAreasAdminApiCreateAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArea(requestParameters: DevelopmentAreasAdminApiCreateAreaRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentAreaResponse> {
            return localVarFp.createArea(requestParameters.createDevelopmentAreaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a dimension in an area
         * @param {DevelopmentAreasAdminApiCreateDimensionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDimension(requestParameters: DevelopmentAreasAdminApiCreateDimensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentDimensionResponse> {
            return localVarFp.createDimension(requestParameters.areaId, requestParameters.createDevelopmentDimensionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a development area
         * @param {DevelopmentAreasAdminApiDeactivateAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateArea(requestParameters: DevelopmentAreasAdminApiDeactivateAreaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateArea(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deactivate a dimension
         * @param {DevelopmentAreasAdminApiDeactivateDimensionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateDimension(requestParameters: DevelopmentAreasAdminApiDeactivateDimensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deactivateDimension(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all development areas, including inactive ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll3(options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentAreaResponse>> {
            return localVarFp.getAll3(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Coverage matrix of active dimensions by linked active questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoverage(options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentCoverageResponse> {
            return localVarFp.getCoverage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a development area
         * @param {DevelopmentAreasAdminApiUpdateAreaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArea(requestParameters: DevelopmentAreasAdminApiUpdateAreaRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentAreaResponse> {
            return localVarFp.updateArea(requestParameters.id, requestParameters.updateDevelopmentAreaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a dimension
         * @param {DevelopmentAreasAdminApiUpdateDimensionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDimension(requestParameters: DevelopmentAreasAdminApiUpdateDimensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevelopmentDimensionResponse> {
            return localVarFp.updateDimension(requestParameters.id, requestParameters.updateDevelopmentDimensionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createArea operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiCreateAreaRequest
 */
export interface DevelopmentAreasAdminApiCreateAreaRequest {
    /**
     * 
     * @type {CreateDevelopmentAreaRequest}
     * @memberof DevelopmentAreasAdminApiCreateArea
     */
    readonly createDevelopmentAreaRequest: CreateDevelopmentAreaRequest
}

/**
 * Request parameters for createDimension operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiCreateDimensionRequest
 */
export interface DevelopmentAreasAdminApiCreateDimensionRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentAreasAdminApiCreateDimension
     */
    readonly areaId: number

    /**
     * 
     * @type {CreateDevelopmentDimensionRequest}
     * @memberof DevelopmentAreasAdminApiCreateDimension
     */
    readonly createDevelopmentDimensionRequest: CreateDevelopmentDimensionRequest
}

/**
 * Request parameters for deactivateArea operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiDeactivateAreaRequest
 */
export interface DevelopmentAreasAdminApiDeactivateAreaRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentAreasAdminApiDeactivateArea
     */
    readonly id: number
}

/**
 * Request parameters for deactivateDimension operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiDeactivateDimensionRequest
 */
export interface DevelopmentAreasAdminApiDeactivateDimensionRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentAreasAdminApiDeactivateDimension
     */
    readonly id: number
}

/**
 * Request parameters for updateArea operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiUpdateAreaRequest
 */
export interface DevelopmentAreasAdminApiUpdateAreaRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentAreasAdminApiUpdateArea
     */
    readonly id: number

    /**
     * 
     * @type {UpdateDevelopmentAreaRequest}
     * @memberof DevelopmentAreasAdminApiUpdateArea
     */
    readonly updateDevelopmentAreaRequest: UpdateDevelopmentAreaRequest
}

/**
 * Request parameters for updateDimension operation in DevelopmentAreasAdminApi.
 * @export
 * @interface DevelopmentAreasAdminApiUpdateDimensionRequest
 */
export interface DevelopmentAreasAdminApiUpdateDimensionRequest {
    /**
     * 
     * @type {number}
     * @memberof DevelopmentAreasAdminApiUpdateDimension
     */
    readonly id: number

    /**
     * 
     * @type {UpdateDevelopmentDimensionRequest}
     * @memberof DevelopmentAreasAdminApiUpdateDimension
     */
    readonly updateDevelopmentDimensionRequest: UpdateDevelopmentDimensionRequest
}

/**
 * DevelopmentAreasAdminApi - object-oriented interface
 * @export
 * @class DevelopmentAreasAdminApi
 * @extends {BaseAPI}
 */
export class DevelopmentAreasAdminApi extends BaseAPI {
    /**
     * 
     * @summary Create a development area
     * @param {DevelopmentAreasAdminApiCreateAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public createArea(requestParameters: DevelopmentAreasAdminApiCreateAreaRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).createArea(requestParameters.createDevelopmentAreaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a dimension in an area
     * @param {DevelopmentAreasAdminApiCreateDimensionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public createDimension(requestParameters: DevelopmentAreasAdminApiCreateDimensionRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).createDimension(requestParameters.areaId, requestParameters.createDevelopmentDimensionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a development area
     * @param {DevelopmentAreasAdminApiDeactivateAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public deactivateArea(requestParameters: DevelopmentAreasAdminApiDeactivateAreaRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).deactivateArea(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deactivate a dimension
     * @param {DevelopmentAreasAdminApiDeactivateDimensionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public deactivateDimension(requestParameters: DevelopmentAreasAdminApiDeactivateDimensionRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).deactivateDimension(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all development areas, including inactive ones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public getAll3(options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).getAll3(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Coverage matrix of active dimensions by linked active questionnaires
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public getCoverage(options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).getCoverage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a development area
     * @param {DevelopmentAreasAdminApiUpdateAreaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public updateArea(requestParameters: DevelopmentAreasAdminApiUpdateAreaRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).updateArea(requestParameters.id, requestParameters.updateDevelopmentAreaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a dimension
     * @param {DevelopmentAreasAdminApiUpdateDimensionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasAdminApi
     */
    public updateDimension(requestParameters: DevelopmentAreasAdminApiUpdateDimensionRequest, options?: RawAxiosRequestConfig) {
        return DevelopmentAreasAdminApiFp(this.configuration).updateDimension(requestParameters.id, requestParameters.updateDevelopmentDimensionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

